import React, {useEffect, useState} from 'react'
import {Box, FormControl, FormHelperText, Input, InputAdornment, InputLabel, Select as MaterialSelect,TextField,Typography} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import {useHistory} from "react-router-dom";
import {makeStyles} from '@material-ui/core/styles';
import {green} from '@material-ui/core/colors';
import ModalTam from '../Generales/ModalTam';
import {toast} from 'react-toastify';
import {ErrorGeneral, llamaApiCargaToken} from '../funciones/ClienteAxios';
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment/moment";
import dayjs from "dayjs"; 
import utc from 'dayjs/plugin/utc.js'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex', flexWrap: 'noWrap',  flexDirection: "column" ,//alignItems: 'center',
    }, wrapper: {
        marginTop: 0, paddingTop: 0, position: 'relative',
    },
    buttonGuardar: {color: green[500],}, buttonProgress: {
        color: green[500], position: 'absolute', top: '50%', left: '50%', marginTop: -12, marginLeft: -12,
    },
}));

export default function ModalNuevoEditar({ modalAbierto, setModalAbierto, titulo,  Balancin, auxRegistro}) {
    dayjs.extend(utc);   
    const idusu = localStorage.getItem('UsuId');     
    let history = useHistory();
    const classes = useStyles();
    const source = axios.CancelToken.source();
    const [aviso, setAviso] = React.useState(false);
    const [mensaje, setMensaje] = React.useState('');
    const [tipoAdvertencia, setTipoAdvertencia] = React.useState('success');
    const [registro, setRegistro] = React.useState({
        Id: 0, Nota: "", UbicId: 0,         
        colorLeyenda:process.env.REACT_APP_COLOR
    })
    const [espera, setEspera] = React.useState(false);
    const {Id, Nota,     } = registro;
    const [fechas, setFechas] = useState({inicio: new Date, FMtto: new Date});
    const {inicio, FMtto} = fechas

    useEffect(() => {
        //console.log(auxRegistro);
        
        setFechas({inicio:dayjs.utc(auxRegistro.RodFchini).format("YYYY-MM-DDTHH:mm:ss"), 
         } )
        setRegistro({...registro,        })
    }, [Balancin])

 

    const BGTexto =(desgaste)=>{
        let color="", bandera=true
        const auxTDesgaste = desgaste /100
        if (bandera && (auxTDesgaste <= 0.25 )) {
            color="#19A11E"
            bandera=false
        }
        if (bandera && (auxTDesgaste >= 0.26 ) && (auxTDesgaste <= 0.50 )) {
            color="#E1AA06"
            bandera=false
        }
        if (bandera && (auxTDesgaste >= 0.51 ) && (auxTDesgaste <= 0.74 )) {
            color="#FA4307"
            bandera=false
        }
        if (bandera && (auxTDesgaste >= 0.75 ) ) {
            color="#FF1744"        
        }

        return color
    }

    const registrarNvo = ( ) => {
     
        const auxFMtto=moment(FMtto).format("YYYY-MM-DDTHH:mm:ss")
   
        const data = qs.stringify({                              
            Usuario:idusu,
            Balancin:Balancin.Id,
            Llave:0,
            Status:1,                
            Fecha:auxFMtto,
            Nota:Nota,
            idDispositivo: 'iu87ygubhjjij',
        });
        const url = "/pilona/balancin/bitacora/new-edit";
       
        function respuesta(aux) {
            if (aux.respuesta === 1) {
                let mensaje = "Se edito correctamente."
                setTipoAdvertencia("success")
                setMensaje(mensaje);
                setAviso(true)
                toast.success(mensaje, {
                    pauseOnFocusLoss: false, toastId: `edit-bal${aux.mensaje}`
                })                  
                              
                setModalAbierto(false)
            }    
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);     
    }

    const mostrarAlertas = (auxMensaje) => {
        setTipoAdvertencia("warning")
        const mensaje = auxMensaje
        setMensaje(mensaje);
        setAviso(true)
    }

    function valNulos(auxMensaje, auxCampo) {
        let valida = false
        if (auxCampo !== '' && auxCampo !== '0' && auxCampo !== 0 && auxCampo !== null && auxCampo !== " ") {
            valida = true
        }
        if (!valida) {
            mostrarAlertas(auxMensaje)
        }
        return valida
    }
 

    const guardarParo = () => {
        if (Nota.length === 0 && valNulos("Escribir Descripción", '') || Nota.length >= 5   ) 
        {
         
            setAviso(false)
            //let auxUbiNom = listUbic.filter((ubic) => ubic.value === parseInt(UbicId))
            registrarNvo()
            
        }
    };

    const onChange = e => {
        setRegistro({
            ...registro, [e.target.name]: e.target.value
        })
    };
 
    const guardarFMtto = auxfecha => {
        setFechas({
            ...fechas,
            FMtto: auxfecha
        })
    };

    return (
    <ModalTam titulo={titulo} modalAbierto={modalAbierto}
        setModalAbierto={setModalAbierto} guardarDatos={guardarParo}
        mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
        aviso={aviso} setAviso={setAviso} espera={espera}
        setEspera={setEspera} tamanio="md" btnDesact={false}
    >
        <form className={classes.root} noValidate autoComplete="off" fullWidth>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            
            
             
           <DateTimePicker
                label="Fecha  " size={"small"} ampm={false}
                value={FMtto} style={{width: '13rem'}}
                onChange={guardarFMtto}
                minDate="2017-03-14" maxDate={new Date()}
                format="dd/MM/yyyy HH:mm"   
                cancelLabel={"Cancelar"} okLabel="Seleccionar"                                                              
            />
            </MuiPickersUtilsProvider>
            <Box mt={1}>
                <Typography component="p" variant="body2" color='primary' 
                    style={{margin:0,marginLeft:.5+'rem'}} >
                    Descripción
                </Typography>  
                <textarea id="descripcion-input" name="Nota" rows="3" maxlength={2000}
                    cols="100" style={{width: 24 + "rem", borderRadius: 3 + 'px'}}
                    value={Nota} onChange={onChange} placeholder="Descripción"
                />
            </Box>
            
            
        </form>
    </ModalTam>);
}
